import { TPartnerReservationCardData } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

type TUpdatePartnerCardDetails = {
  calculationId: string;
  payload: TPartnerReservationCardData;
};

export const updatePartnerCardDetails = ({
  calculationId,
  payload,
}: TUpdatePartnerCardDetails): Promise<any> =>
  API.put(`/api/accommodation/calculations/${calculationId}/cardData`, payload);
